module.exports = __webpack_public_path__ + "static/media/customer (2).5c363d96.svg";